import React, { useContext } from "react";
import { StudentContext } from "./StudentLayout";

const StudentProfile = () => {
  const { student } = useContext(StudentContext);
  if (!student) return <div className="text-slate-500" data-testid="profile-loading">Loading...</div>;

  const sections = [
    {
      title: "Personal Information",
      fields: [
        ["Full Name", student.fullName],
        ["Parent / Guardian Name", student.parentName],
        ["Email", student.email],
        ["Phone", student.phone],
        ["Gender", student.gender],
        ["Date of Birth", student.dateOfBirth],
      ],
    },
    {
      title: "Academic Details",
      fields: [
        ["University", student.university],
        ["College", student.college],
        ["University Roll Number", student.universityRollNumber],
        ["University Registration Number", student.universityRegNumber],
        ["Degree", student.degree],
        ["Department / Stream", student.department],
        ["Class / Semester", student.classSemester],
        ["Academic Session", student.academicSession],
        ["Minor Subject", student.minorSubject],
        ["Year of Passing", student.yearOfPassing],
        ["Batch", student.batch],
      ],
    },
    {
      title: "Internship & Account",
      fields: [
        ["Student ID", student.studentId],
        ["Subject", student.subjectName],
        ["Domain", student.domain],
        ["Selected Internship", student.selectedInternship],
        ["Amount Paid", `₹${student.amountPaid || 0}`],
        ["Payment Status", student.paymentStatus],
        ["Account Status", student.accountStatus],
        ["Certificate Status", student.certificateStatus],
      ],
    },
  ];

  return (
    <div data-testid="student-profile">
      <div className="mb-8">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600 mb-2">My Account</div>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">Profile</h1>
        <p className="mt-1 text-slate-600">Read-only profile information. Contact admin for any changes.</p>
      </div>

      <div className="space-y-6">
        {sections.map((s) => (
          <div key={s.title} className="bg-white border border-slate-200 rounded-xl p-6">
            <h2 className="font-heading font-bold text-lg text-slate-900 mb-4">{s.title}</h2>
            <div className="grid md:grid-cols-2 gap-x-8 gap-y-4">
              {s.fields.map(([k, v]) => (
                <div key={k} className="flex justify-between border-b border-slate-100 pb-2">
                  <span className="text-sm text-slate-500">{k}</span>
                  <span className="text-sm font-medium text-slate-900 text-right">{v || "—"}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudentProfile;
